let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kNWVn")).then(() => parcelRequire('cZaLN'));